/* eslint-disable import/no-anonymous-default-export */

import { docodeHexResponse } from "../../_common/common.utils";
import FunderActionTypes from "./funder.types";

const INITIAL_STATE = {
  addFunderDetailsResponse: null,
  updateFunderDetailsResponse: null,
  getFunderListResponse: null,
  getFunderListArr: [],
  fetchFunderDetailsResponse: null,
  fetchFunderDetailsArr: [],
  deleteFunderDetailsResponse: null,
  funderListResponseArr: [],
  funderListFetchResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD LENDER DETAILS START *********************** */
    case FunderActionTypes.ADD_FUNDER_DETAILS_SUCCESS:
      return { ...state, addFunderDetailsResponse: action.payload };

    case FunderActionTypes.ADD_FUNDER_DETAILS_FAILURE:
      return { ...state, addFunderDetailsResponse: action.payload };

    case FunderActionTypes.ADD_FUNDER_DETAILS_RESPONSE_CHANGED:
      return { ...state, addFunderDetailsResponse: null };
    /** ***************** ADD LENDER DETAILS END *********************** */

    /** ***************** UPDATE LENDER DETAILS START *********************** */
    case FunderActionTypes.UPDATE_FUNDER_DETAILS_SUCCESS:
      return { ...state, updateFunderDetailsResponse: action.payload };

    case FunderActionTypes.UPDATE_FUNDER_DETAILS_FAILURE:
      return { ...state, updateFunderDetailsResponse: action.payload };

    case FunderActionTypes.UPDATE_FUNDER_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateFunderDetailsResponse: null };
    /** ***************** UPDATE LENDER DETAILS END *********************** */

    /** ***************** GET LENDER DETAILS START *********************** */
    case FunderActionTypes.GET_FUNDER_LIST_SUCCESS:
      return {
        ...state,
        getFunderListResponse: action.payload,
        getFunderListArr: docodeHexResponse(
          action.payload,
          "GetAllFunderPaginationKey",
        ),
      };

    case FunderActionTypes.GET_FUNDER_LIST_FAILURE:
      return {
        ...state,
        getFunderListResponse: action.payload,
        getFunderListArr: [],
      };

    case FunderActionTypes.GET_FUNDER_LIST_RESPONSE_CHANGED:
      return { ...state, getFunderListResponse: null };
    /** ***************** GET LENDER DETAILS END *********************** */

    /** ***************** FETCH LENDER DETAILS START *********************** */
    case FunderActionTypes.FETCH_FUNDER_DETAILS_SUCCESS:
      return {
        ...state,
        fetchFunderDetailsResponse: action.payload,
        fetchFunderDetailsArr: docodeHexResponse(
          action.payload,
          "FetchFunderKey",
        ),
      };

    case FunderActionTypes.FETCH_FUNDER_DETAILS_FAILURE:
      return { ...state, fetchFunderDetailsResponse: action.payload };

    case FunderActionTypes.FETCH_FUNDER_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchFunderDetailsResponse: null,
        fetchFunderDetailsArr: [],
      };
    /** ***************** FETCH LENDER DETAILS END *********************** */

    /** ***************** DELETE LENDER DETAILS START *********************** */
    case FunderActionTypes.DELETE_FUNDER_DETAILS_SUCCESS:
      return { ...state, deleteFunderDetailsResponse: action.payload };

    case FunderActionTypes.DELETE_FUNDER_DETAILS_FAILURE:
      return { ...state, deleteFunderDetailsResponse: action.payload };

    case FunderActionTypes.DELETE_FUNDER_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteFunderDetailsResponse: null };
    /** ***************** DELETE LENDER DETAILS END *********************** */

    /** ***************** START FETCH LENDER LIST DETAILS ******************************* */
    case FunderActionTypes.FUNDER_LIST_FETCH_SUCCESS:
      return {
        ...state,
        funderListFetchResponse: action.payload,
        funderListResponseArr: docodeHexResponse(
          action.payload,
          "AllFunderMasterKey",
        ),
      };

    case FunderActionTypes.FUNDER_LIST_FETCH_FAILURE:
      return {
        ...state,
        funderListFetchResponse: action.payload,
        funderListResponseArr: [],
      };

    case FunderActionTypes.FUNDER_LIST_FETCH_RESPONSE_CHANGED:
      return { ...state, funderListFetchResponse: null };

    /** ***************** END FETCH LENDER LIST DETAILS ******************************* */

    default:
      return state;
  }
};
